import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {SketchPicker} from 'react-color';

import './colorPicker.scss';

const ColorSwatch = props => {
  const [showColor, setShowColor] = useState(false);

  return (
    <>
      <div
        className="mhd--color-swatch"
        onClick={() => setShowColor(!showColor)}
      >
        <div
          className="mhd--color-swatch--color"
          style={{background: props.color}}
        />
      </div>

      <div className="mhd--color-swatch--color--text">{props.color}</div>

      {showColor && (
        <div className="mhd--color-swatch--popover">
          <div
            className="mhd--color-swatch--cover"
            onClick={() => setShowColor(false)}
          />

          <SketchPicker disableAlpha {...props} />
        </div>
      )}
    </>
  );
};

ColorSwatch.propTypes = {
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,

  // functions
  onChangeComplete: PropTypes.func.isRequired,
};

export default ColorSwatch;



// WEBPACK FOOTER //
// ./src/components/Common/Form/ColorSwatch.js